export const TESTIMONIALS = [
  {
    name: "Andi",
    area: "Batam Center",
    rating: 5,
    text:
      "Pelayanan cepat, teknisi ramah dan menjelaskan kerusakan dengan detail. Listrik rumah langsung normal.",
    service: "Perbaikan Listrik",
  },
  {
    name: "Rina",
    area: "Sekupang",
    rating: 5,
    text:
      "AC langsung dingin lagi setelah dicuci. Harganya juga transparan, tidak ada biaya tambahan aneh-aneh.",
    service: "Service AC",
  },
  {
    name: "Budi",
    area: "Nagoya",
    rating: 5,
    text:
      "Instalasi CCTV 4 kamera di ruko saya selesai dalam 1 hari, rapi, dan bisa langsung dipantau dari HP.",
    service: "Instalasi CCTV",
  },
  {
    name: "Ibu Sari",
    area: "Tiban",
    rating: 5,
    text:
      "Kulkas yang sempat mati total sudah hidup normal lagi. Teknisinya datang tepat waktu, proses cepat.",
    service: "Service Kulkas",
  },
  {
    name: "Pak Hendra",
    area: "Batu Aji",
    rating: 5,
    text:
      "Panel distribusi workshop saya dikerjakan profesional, lengkap dengan laporan kondisi. Tim ini memang beda dari tukang biasa.",
    service: "Panel Industri",
  },
  {
    name: "Dewi",
    area: "Bengkong",
    rating: 5,
    text:
      "Water heater di kos saya dipasang rapi dan aman. Groundingnya juga diperiksa. Recommended banget!",
    service: "Instalasi Water Heater",
  },
];
